
import {Vue, Component, Prop} from "vue-property-decorator";
@Component({})
export default class Snackbar extends  Vue {
  @Prop({default: false})
  public isMobile: boolean;

  get currentAlert(): any {
    return this.$store.state.alerts.currentAlert;
  }

  private closeAlert(): void {
    this.$store.commit("alerts/hideAlert");
  }
}
